import { getAppServices } from "@10x/coreapp";
import {
	RESET,
	UPDATE_CAN_CHANGE,
	UPDATE_PROPERTIES,
	UPDATE_PROPERTY,
	UPDATE_PROPERTY_TYPE,
	UPDATE_SEARCH_PARAMS,
	UPDATE_UNITS
} from "./core/actions";
import { ProjectProperty } from "@eres/ejari-api/Entity/LeasedProperties";
import { SearchParams } from "./api/entities";
import { BUILDING_AND_UNIT } from "./web/screens/AddProperty";
import { Lookup } from "@eres/ejari-api/Entity";

export function updateSearchParams( params: SearchParams ) {
	getAppServices().storeService.getStore().dispatch( {
		type: UPDATE_SEARCH_PARAMS,
		payload: params,
	} );
}

export function updateProperties( properties: ProjectProperty[], canChange?: boolean, pType?: Lookup ) {
	const store = getAppServices().storeService.getStore();
	store.dispatch( {
		type: UPDATE_PROPERTIES,
		payload: properties,
	} );
	store.dispatch( {
		type: UPDATE_PROPERTY_TYPE,
		payload: pType,
	} );
	store.dispatch( {
		type: UPDATE_CAN_CHANGE,
		payload: canChange,
	} );
}

export function updateProperty( property?: ProjectProperty ) {
	getAppServices().storeService.getStore().dispatch( {
		type: UPDATE_PROPERTY,
		payload: property,
	} );
}

export function updateUnits( units: ProjectProperty[] ) {
	const store = getAppServices().storeService.getStore();
	store.dispatch( {
		type: UPDATE_UNITS,
		payload: units,
	} );
	store.dispatch( {
		type: UPDATE_PROPERTY_TYPE,
		payload: BUILDING_AND_UNIT,
	} );
	store.dispatch( {
		type: UPDATE_CAN_CHANGE,
		payload: false,
	} );
}

export function resetDataForAddMore( isFromLand?: boolean ) {
	const store = getAppServices().storeService.getStore();
	if ( !isFromLand ) {
		store.dispatch( {
			type: UPDATE_SEARCH_PARAMS,
		} );
	}
	store.dispatch( {
		type: UPDATE_PROPERTIES,
	} );
	store.dispatch( {
		type: UPDATE_UNITS,
	} );
	store.dispatch( {
		type: UPDATE_PROPERTY_TYPE,
	} );
	store.dispatch( {
		type: UPDATE_CAN_CHANGE,
	} );
}

export function resetData() {
	getAppServices().storeService.getStore().dispatch( {
		type: RESET,
	} );
}
